export const fileDownloadRetryLinkContent = {
  variationTypes: {
    Any: "Any"
  },
  Any: {
    retry: {
      message: "If your document doesn't open within a few seconds, please",
      button: {
        label: "click here",
        aria: {
          label: "Backup link to download"
        }
      }
    }
  }
};
